<template>
    <dashboard>
        <row>
            <panel size="col-5" class="filters">
                <h3 slot="title">Filters</h3>
                <div class="filter-item">
                    <h4>Team</h4>
                    <app-tag
                        v-if="team"
                        size="small"
                        closable
                        @close="removeTeam()">{{ team.name }}</app-tag>
                    <app-button v-else @click="showTeamPicker = true">Pick Team</app-button>
                </div>
                <team-picker v-model="showTeamPicker" @selected-team="addTeam">
                    <template slot="title">Select Team</template>
                </team-picker>
            </panel>
            <panel size="col-19">
                <h2 slot="title">Team Report</h2>

                <app-alert v-if="!team">This is a downloadable report only. Please pick a team on the left in order to download the report.</app-alert>
                <app-alert v-else type="success">To continue, click the button below to generate and download your report.</app-alert>
                <app-alert v-if="error" type="error">{{ error }}</app-alert>
                <br >
                <app-button
                    size="large"
                    icon="icon-download"
                    @click="handleDownload">
                    Download Report
                </app-button>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import table from '@/mixins/table'
import download from '@/mixins/download'

import TeamPicker from '../Team/TeamPicker'

export default {
    name: 'page-reports-token',
    components: {
        TeamPicker
    },
    mixins: [table, download],
    props: {
        uuid: String
    },
    data() {
        return {
            showTeamPicker: false,
            tableParamKeys: ['uuid'],
            team: null
        }
    },
    computed: {
        ...mapState({
            teamsList: ({ params }) => params.teams,
            authToken: ({ me }) => me.token
        })
    },
    mounted() {
        this.paramsChanged(this.getParameters())
    },
    methods: {
        ...mapActions(['getTokenReport']),
        handleDownload() {
            this.postParameters('/api/v2/download/report/team',
                this.getParameters(),
                this.authToken)
        },
        addTeam(team) {
            this.uuid = team.uuid
            this.team = team
        },
        removeTeam() {
            this.uuid = null
            this.team = null
        }
    }
}
</script>

<style lang="stylus"></style>
